import React from 'react';
import { MEDIA_TYPES } from '../../../../constants';
import clsx from 'clsx';

import useCommonModal from '../../../../hooks/useCommonModal';
import { mediaCache } from '../../../../service/mediaCache';
import CommonModal from '../../../../components/common-modal/CommonModal';
import Activ8Image from '../../../components/content-media/image/Activ8Image';
import Activ8Video from '../../../components/content-media/video/Activ8Video';

import scss from './MediaSelectSlide.module.scss';

function LocalMediaSlide({ slide }) {
  const { isOpen, handleOpenModal, handleCloseModal } = useCommonModal({ initialState: false });
  const { id, mediaType } = slide;
  const mediaUrl = mediaCache.get(id);

  const handlePreview = () => {
    handleOpenModal();
  };

  return (
    <div className={clsx(scss.wrapper)}>
      {mediaType === MEDIA_TYPES.IMAGE && (
        <Activ8Image
          image={slide}
          src={mediaUrl}
          onPreview={handlePreview}
          backgroundImageStyle={{ borderTopRightRadius: '0.5rem', borderBottomRightRadius: '0.5rem' }}
        />
      )}
      {mediaType === MEDIA_TYPES.VIDEO && <Activ8Video src={mediaUrl} />}
      <PreviewModal isOpen={isOpen} onClose={handleCloseModal} slide={slide} mediaUrl={mediaUrl} />
    </div>
  );
}

export default LocalMediaSlide;

const PreviewModal = ({ isOpen, onClose, slide, mediaUrl }) => {
  return (
    <CommonModal isOpen={isOpen} onClose={onClose} isAnimated>
      <div className={scss.previewModal}>
        <Activ8Image
          image={slide}
          src={mediaUrl}
          backgroundImageStyle={{ borderTopRightRadius: '0.5rem', borderBottomRightRadius: '0.5rem' }}
        />
      </div>
    </CommonModal>
  );
};
